import { render, staticRenderFns } from "./TestPaperReport.vue?vue&type=template&id=56031a0f&scoped=true"
import script from "./TestPaperReport.vue?vue&type=script&lang=js"
export * from "./TestPaperReport.vue?vue&type=script&lang=js"
import style0 from "./TestPaperReport.vue?vue&type=style&index=0&id=56031a0f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56031a0f",
  null
  
)

export default component.exports